module.exports = __webpack_public_path__ + "img/zh-CN.a1fab130.png";